import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { shouldForwardProp } from '@ori/presentation-utils';
import { MenuItem, Select, styled, Tab, Tabs } from '@ori-ui/mui';
export var tabIndicatorStyle = {
  style: {
    display: 'none'
  }
};
export var Root = styled(Tabs)(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.palette.grey[50],
    height: 54,
    width: '100%',
    borderBottom: "1px solid ".concat(theme.palette.grey[200])
  };
});
export var MobileRoot = styled(Select)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.palette.text.primary,
    background: theme.palette.grey[50],
    borderBottom: "1px solid ".concat(theme.palette.grey[200]),
    boxShadow: 'none',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    height: 54,
    '& svg': {
      fontSize: theme.typography.pxToRem(32),
      padding: theme.spacing(0, 3)
    },
    '& .MuiSelect-select': {
      marginLeft: theme.spacing(2)
    }
  };
});
export var MobileItem = styled(MenuItem)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    padding: theme.spacing(4, 0, 4, 8),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold
  };
});
export var DesktopItem = styled(Tab, {
  shouldForwardProp: shouldForwardProp(['value'])
})(function (_ref4) {
  var theme = _ref4.theme,
    hoverActiveColor = _ref4.hoverActiveColor;
  return _defineProperty({
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
    minWidth: 60,
    height: 54,
    textTransform: 'uppercase',
    opacity: 1,
    '&:hover': {
      color: hoverActiveColor !== null && hoverActiveColor !== void 0 ? hoverActiveColor : theme.palette.text.secondary
    },
    '&.active': {
      color: hoverActiveColor !== null && hoverActiveColor !== void 0 ? hoverActiveColor : theme.palette.text.secondary
    },
    '&.Mui-selected': {
      color: hoverActiveColor !== null && hoverActiveColor !== void 0 ? hoverActiveColor : theme.palette.text.secondary
    }
  }, theme.breakpoints.up('md'), {
    marginRight: "".concat(theme.spacing(8)),
    fontSize: theme.typography.pxToRem(16)
  });
});
//# sourceMappingURL=categoryBar.js.map